import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

function NotificationMenuDropdown({
  children = null,
  button = null,
  className = 'tv-filter-list__element',
  buttonClass = 'tv-notification_header',
  visible = false,
  setVisible = () => {},
}) {
  const topNavigationHandler = () => {
    const elementArray = document.getElementsByClassName(
      'tv-main_layout__container',
    );
    if (elementArray.length === 1) {
      const element = elementArray[0];
      if (visible) {
        element.classList.add('tv-main_layout__container-hidden');
      } else {
        element.classList.remove('tv-main_layout__container-hidden');
      }
    }
  };

  useEffect(() => {
    topNavigationHandler();
  }, [visible]);

  const toggleMenu = () => {
    setVisible(!visible);
  };

  const onBlur = event => {
    const { currentTarget } = event;
    setTimeout(() => {
      if (!currentTarget.contains(document.activeElement)) {
        // toggleMenu();
        setVisible(false);
      }
    }, 250);
  };

  return (
    <div onBlur={onBlur} className={className}>
      <div
        role="button"
        tabIndex="-1"
        onClick={toggleMenu}
        onKeyDown={() => {}}
        className={buttonClass}
      >
        {button}
      </div>
      {visible && children}
    </div>
  );
}

NotificationMenuDropdown.propTypes = {
  children: PropTypes.node,
  button: PropTypes.node,
  className: PropTypes.string,
  buttonClass: PropTypes.string,
  visible: PropTypes.bool,
  setVisible: PropTypes.func,
};

export default NotificationMenuDropdown;
